// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs_have_a_question-section {
    border-radius: 8px;
    color: #000;
    font-size: 12px;
    border: solid 1px;
    background: linear-gradient(to right, #25c9d0 0%, #db487e 100%);
    text-transform: capitalize;
    border: 0;
    outline: 0;
    position: relative;
    z-index: 1;
    padding: 16px;
    /* width: 770px; */
    box-sizing: border-box;
    overflow: auto;

}
.rs_have_a_question-section::before {
    content: "";
    display: block;
    position: absolute;
    left: 1px;
    right: 1px;
    top: 1px;
    bottom: 1px;
    z-index: -1;
    background: #fff;
    border-radius: 8px;
}

.rs_have_a_question-section .rs_header {
    display: flex;
    gap: 16px;
    align-items: start;

}

.rs_have_a_question-section .rs_header .rs_text h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.16px;
    margin: 0;
    text-transform: none;
    text-transform: initial;

}


.rs_have_a_question-section .rs_header .rs_text h3 span {
    background: #EBFEFF;
    display: inline-block;
    border-radius: 4px;
    width: 46px;
    text-align: center;
    margin-right: 4px;
}

.rs_have_a_question-section .rs_header .rs_text p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    margin: 0;
    margin-top: 4px;
    text-transform: none;
    text-transform: initial;

}

.rs_chatbot-input {
    padding: 12px;
    border-radius: 6px;
    border: 1px solid #25C9D0;
    background: #FFF;
    width: 100%;
    font-size: 16px;
    color: #05212A;
    font-weight: 400;
    animation: 2s ease-out;
    padding-right: 70px;
}

.rs_chatbot-input:focus-visible {
    outline: 1px solid #25C9D0;
}

.rs_chatbot-input::placeholder {
    font-size: 14px;
}

.rs_chatbot-chat-btn-send {
    position: absolute;
    right: 0px;
    top: 0px;
    background: transparent !important;
    transition: transform 0.3s ease-in-out;
    width: 60px;
    height: 47px;
    border: none;
    border-bottom-right-radius: 5px;
    color: #999999;
    padding: 0;
    cursor: pointer;
}


.rs_chatbot-input-form {
    position: relative;
    width: 95%;
    margin-top: 20px;
    /* text-align: center; */
    /* background-color: red; */
}

.rs_chatbot-input-form form {
    width: 95%;
    /* margin: 24px auto 16px; */
    margin-top: 24px;
    margin-bottom: 16px;

}

.rs_activities-btn {
    display: flex;
    /* flex-direction: column; */
    /* align-items: flex-start; */
    justify-content: center;
    gap: 10px;
    margin-top: 8px;
}

.rs_cta-btn {
    position: relative;
    display: inline-block;
    background: transparent;
    padding: 5px 16px !important;
    border-radius: 5px;
    border: 0;
    z-index: 1;
    overflow: hidden;
    text-transform: none !important;
    width: 100%;
    color: #666666;
    font-size: 0.775rem;
    font-family: "Open Sans", sans-serif !important;
    letter-spacing: 0.26px;
    font-weight: 400 !important;
    white-space: nowrap;

}

.rs_cta-btn::before,
.rs_cta-btn::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    z-index: -1;
}

.rs_cta-btn::before {
    background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E);
    padding: 1px 1px;
    box-sizing: border-box;
}

.rs_cta-btn::after {
    background: #fff;
    margin: 1px 1px;
    box-sizing: border-box;
}



.rs_chatbot-input-form {
    display: flex;
    width: 98%;
}

/* Model css  */
.rs_modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    z-index: 9999;
}

.rs_modal {
    position: fixed;
    background: white;
    /* padding: 20px; */
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    width: 950px;
    height: 640px;
    display: flex;
    flex-direction: column;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.rs_modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* width: 100%; */
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    padding: 8px 8px 8px 24px;

}

.rs_chat-header-icon {
    display: flex;
    gap: 8px;
    align-items: center;
}

.rs_chat-header-icon h3 {
    font-size: 20px;
    color: #333;
    font-weight: 700;
    line-height: 30px;
    margin: 0;

}

.rs_modal-body {

    flex-grow: 1;
    overflow-y: auto;
    padding: 24px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
}

.rs_chat-message {
    padding: 8px;
    margin: 5px;
    border-radius: 5px;
    max-width: 70%;
}

.rs_user-message {

    align-self: flex-end;


    word-wrap: break-word;
    -webkit-word-wrap: break-word;
    background: #f5feff;
    border: 1px solid #1b9298;
    border-radius: 12px 12px 0 12px;
    color: #585858;
    hyphens: auto;
    -webkit-hyphens: auto;
    max-width: 50%;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.26px;
}

.rs_system-message {
    align-self: flex-start;
    border: 1px solid #bebfd3;
    border-radius: 12px 12px 12px 0;
    color: #171a1f;
    font-size: .9rem;
    padding: 10px;
    position: relative;
    text-align: left;
    /* width: 90%; */

}

.rs_modal-footer {
    display: flex;
    padding-top: 0px;
    /* border-top: 1px solid #ddd; */
    position: relative;
    padding: 20px;
}

.rs_modal-footer-container {
    width: 100%;
}

.rs_modal-footer input {
    flex-grow: 1;
    padding: 8px;
    padding-right: 45px;
}

.rs_modal-footer .rs_chatbot-chat-btn-send {
    /* right: 32px; */
    /* top: 4px;  */
    height: 40px;

}

.rs_close-btn {
    background: transparent;
    border: none;
    cursor: pointer;
}

.rs_error {
    color: red;
    font-size: 14px;
    display: none;
    margin-top: 5px;
}

.rs_input-error {
    border: 2px solid red;
}

.rs_chat-message_loading {
    position: absolute;
    bottom: 80px;
}


/* Bouncing Loader */
.rs_bouncing-loader {
    display: flex;
    justify-content: start;
    margin: 40px auto;
}

.rs_bouncing-loader>div {
    width: 12px;
    height: 12px;
    margin: 2px 5px;
    border-radius: 50%;
    background-color: #a3a1a1;
    opacity: 1;
    animation: rs_bouncing-loader 0.6s infinite alternate;
    margin-top: 8px;
}

@keyframes rs_bouncing-loader {
    to {
        opacity: 0.1;
        /* transform: translateY(-16px); */
        transform: translateY(-10px);
    }
}

.rs_bouncing-loader>div:nth-child(2) {
    animation-delay: 0.2s;
}

.rs_bouncing-loader>div:nth-child(3) {
    animation-delay: 0.4s;
}

.rs_bouncing-loader-conditional-cls {
    justify-content: flex-start;
    margin: 10px auto;
    margin-bottom: 4px;
}


/* Large devices (desktops, less than 1200px) */


/* Medium devices (tablets, less than 992px) */
@media (max-width: 991px) {
    .rs_modal {
        width: 80%;
        height: 80vh;
    }

    .rs_activities-btn {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        justify-content: left;
        overflow-x: auto !important;
        margin-top: 8px;
        padding: 0 10px;
        padding-bottom: 8px;
    }

    .rs_activities-btn::-webkit-scrollbar {
        width: 3px !important;
        height: 3px !important;
    }

    .rs_activities-btn::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 18px #e0e1e2;
        border-radius: 2px;
    }

    .rs_activities-btn::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: #999999 !important;
        width: 2px !important;
        height: 2px !important;
    }

    .rs_activities-btn::-webkit-scrollbar-thumb:hover {
        background: #757d85;
    }
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767px) {
    .rs_modal {
        width: 90%;
    }

    .rs_container {
        max-width: 95%;
    }

    .rs_have_a_question-section {
        max-width: 100%;
        width: 98%;
    }

    .rs_chatbot-chat-btn-send {
        /* right: 15px; */
    }

    .rs_chatbot-input {
        /* padding-right: 45px; */
        /* padding-right: 0; */
        width: 100%;
    }

    .rs_chatbot-input-form {
        /* width: 100%; */
    }

    .rs_chatbot-input-form form {
        width: 100%;
    }

    .rs_model-icon img {
        width: 25px;
    }

    .rs_chat-header-icon h3 {
        font-size: 16px;
    }

    .rs_cta-btn {
        font-size: 10px;
        height: 30px;
    }


}`, "",{"version":3,"sources":["webpack://./src/assets/resort-shelly/css/rs-styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,+DAA+D;IAC/D,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;;AAElB;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;IACT,oBAAuB;IAAvB,uBAAuB;;AAE3B;;;AAGA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,oBAAuB;IAAvB,uBAAuB;;AAE3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,kCAAkC;IAClC,sCAAsC;IACtC,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,+CAA+C;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;;AAEvB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gEAAgE;IAChE,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;;;AAIA;IACI,aAAa;IACb,UAAU;AACd;;AAEA,eAAe;AACf;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kCAA0B;YAA1B,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,oBAAoB;IACpB,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;;AAEb;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,oBAAoB;;;IAGpB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;;AAEhB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;;AAGA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,qDAAqD;IACrD,eAAe;AACnB;;AAEA;IACI;QACI,YAAY;QACZ,kCAAkC;QAClC,4BAA4B;IAChC;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA,+CAA+C;;;AAG/C,8CAA8C;AAC9C;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,qBAAqB;QACrB,2BAA2B;QAC3B,eAAe;QACf,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,0CAA0C;QAE1C,kBAAkB;IACtB;;IAEA;QAEI,kBAAkB;QAClB,oCAAoC;QACpC,qBAAqB;QACrB,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,sDAAsD;AACtD;IACI;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;;AAGJ","sourcesContent":[".rs_have_a_question-section {\n    border-radius: 8px;\n    color: #000;\n    font-size: 12px;\n    border: solid 1px;\n    background: linear-gradient(to right, #25c9d0 0%, #db487e 100%);\n    text-transform: capitalize;\n    border: 0;\n    outline: 0;\n    position: relative;\n    z-index: 1;\n    padding: 16px;\n    /* width: 770px; */\n    box-sizing: border-box;\n    overflow: auto;\n\n}\n.rs_have_a_question-section::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 1px;\n    right: 1px;\n    top: 1px;\n    bottom: 1px;\n    z-index: -1;\n    background: #fff;\n    border-radius: 8px;\n}\n\n.rs_have_a_question-section .rs_header {\n    display: flex;\n    gap: 16px;\n    align-items: start;\n\n}\n\n.rs_have_a_question-section .rs_header .rs_text h3 {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.16px;\n    margin: 0;\n    text-transform: initial;\n\n}\n\n\n.rs_have_a_question-section .rs_header .rs_text h3 span {\n    background: #EBFEFF;\n    display: inline-block;\n    border-radius: 4px;\n    width: 46px;\n    text-align: center;\n    margin-right: 4px;\n}\n\n.rs_have_a_question-section .rs_header .rs_text p {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    margin: 0;\n    margin-top: 4px;\n    text-transform: initial;\n\n}\n\n.rs_chatbot-input {\n    padding: 12px;\n    border-radius: 6px;\n    border: 1px solid #25C9D0;\n    background: #FFF;\n    width: 100%;\n    font-size: 16px;\n    color: #05212A;\n    font-weight: 400;\n    animation: 2s ease-out;\n    padding-right: 70px;\n}\n\n.rs_chatbot-input:focus-visible {\n    outline: 1px solid #25C9D0;\n}\n\n.rs_chatbot-input::placeholder {\n    font-size: 14px;\n}\n\n.rs_chatbot-chat-btn-send {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    background: transparent !important;\n    transition: transform 0.3s ease-in-out;\n    width: 60px;\n    height: 47px;\n    border: none;\n    border-bottom-right-radius: 5px;\n    color: #999999;\n    padding: 0;\n    cursor: pointer;\n}\n\n\n.rs_chatbot-input-form {\n    position: relative;\n    width: 95%;\n    margin-top: 20px;\n    /* text-align: center; */\n    /* background-color: red; */\n}\n\n.rs_chatbot-input-form form {\n    width: 95%;\n    /* margin: 24px auto 16px; */\n    margin-top: 24px;\n    margin-bottom: 16px;\n\n}\n\n.rs_activities-btn {\n    display: flex;\n    /* flex-direction: column; */\n    /* align-items: flex-start; */\n    justify-content: center;\n    gap: 10px;\n    margin-top: 8px;\n}\n\n.rs_cta-btn {\n    position: relative;\n    display: inline-block;\n    background: transparent;\n    padding: 5px 16px !important;\n    border-radius: 5px;\n    border: 0;\n    z-index: 1;\n    overflow: hidden;\n    text-transform: none !important;\n    width: 100%;\n    color: #666666;\n    font-size: 0.775rem;\n    font-family: \"Open Sans\", sans-serif !important;\n    letter-spacing: 0.26px;\n    font-weight: 400 !important;\n    white-space: nowrap;\n\n}\n\n.rs_cta-btn::before,\n.rs_cta-btn::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-radius: inherit;\n    z-index: -1;\n}\n\n.rs_cta-btn::before {\n    background: linear-gradient(to right, #25C9D0, #fbee77, #DB487E);\n    padding: 1px 1px;\n    box-sizing: border-box;\n}\n\n.rs_cta-btn::after {\n    background: #fff;\n    margin: 1px 1px;\n    box-sizing: border-box;\n}\n\n\n\n.rs_chatbot-input-form {\n    display: flex;\n    width: 98%;\n}\n\n/* Model css  */\n.rs_modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(5px);\n    z-index: 9999;\n}\n\n.rs_modal {\n    position: fixed;\n    background: white;\n    /* padding: 20px; */\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n    width: 950px;\n    height: 640px;\n    display: flex;\n    flex-direction: column;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.rs_modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    /* width: 100%; */\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 10px;\n    padding: 8px 8px 8px 24px;\n\n}\n\n.rs_chat-header-icon {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n.rs_chat-header-icon h3 {\n    font-size: 20px;\n    color: #333;\n    font-weight: 700;\n    line-height: 30px;\n    margin: 0;\n\n}\n\n.rs_modal-body {\n\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 24px;\n    padding-bottom: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.rs_chat-message {\n    padding: 8px;\n    margin: 5px;\n    border-radius: 5px;\n    max-width: 70%;\n}\n\n.rs_user-message {\n\n    align-self: flex-end;\n\n\n    word-wrap: break-word;\n    -webkit-word-wrap: break-word;\n    background: #f5feff;\n    border: 1px solid #1b9298;\n    border-radius: 12px 12px 0 12px;\n    color: #585858;\n    hyphens: auto;\n    -webkit-hyphens: auto;\n    max-width: 50%;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    letter-spacing: 0.26px;\n}\n\n.rs_system-message {\n    align-self: flex-start;\n    border: 1px solid #bebfd3;\n    border-radius: 12px 12px 12px 0;\n    color: #171a1f;\n    font-size: .9rem;\n    padding: 10px;\n    position: relative;\n    text-align: left;\n    /* width: 90%; */\n\n}\n\n.rs_modal-footer {\n    display: flex;\n    padding-top: 0px;\n    /* border-top: 1px solid #ddd; */\n    position: relative;\n    padding: 20px;\n}\n\n.rs_modal-footer-container {\n    width: 100%;\n}\n\n.rs_modal-footer input {\n    flex-grow: 1;\n    padding: 8px;\n    padding-right: 45px;\n}\n\n.rs_modal-footer .rs_chatbot-chat-btn-send {\n    /* right: 32px; */\n    /* top: 4px;  */\n    height: 40px;\n\n}\n\n.rs_close-btn {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.rs_error {\n    color: red;\n    font-size: 14px;\n    display: none;\n    margin-top: 5px;\n}\n\n.rs_input-error {\n    border: 2px solid red;\n}\n\n.rs_chat-message_loading {\n    position: absolute;\n    bottom: 80px;\n}\n\n\n/* Bouncing Loader */\n.rs_bouncing-loader {\n    display: flex;\n    justify-content: start;\n    margin: 40px auto;\n}\n\n.rs_bouncing-loader>div {\n    width: 12px;\n    height: 12px;\n    margin: 2px 5px;\n    border-radius: 50%;\n    background-color: #a3a1a1;\n    opacity: 1;\n    animation: rs_bouncing-loader 0.6s infinite alternate;\n    margin-top: 8px;\n}\n\n@keyframes rs_bouncing-loader {\n    to {\n        opacity: 0.1;\n        /* transform: translateY(-16px); */\n        transform: translateY(-10px);\n    }\n}\n\n.rs_bouncing-loader>div:nth-child(2) {\n    animation-delay: 0.2s;\n}\n\n.rs_bouncing-loader>div:nth-child(3) {\n    animation-delay: 0.4s;\n}\n\n.rs_bouncing-loader-conditional-cls {\n    justify-content: flex-start;\n    margin: 10px auto;\n    margin-bottom: 4px;\n}\n\n\n/* Large devices (desktops, less than 1200px) */\n\n\n/* Medium devices (tablets, less than 992px) */\n@media (max-width: 991px) {\n    .rs_modal {\n        width: 80%;\n        height: 80vh;\n    }\n\n    .rs_activities-btn {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n        justify-content: left;\n        overflow-x: auto !important;\n        margin-top: 8px;\n        padding: 0 10px;\n        padding-bottom: 8px;\n    }\n\n    .rs_activities-btn::-webkit-scrollbar {\n        width: 3px !important;\n        height: 3px !important;\n    }\n\n    .rs_activities-btn::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 18px #e0e1e2;\n        -webkit-border-radius: 5px;\n        border-radius: 2px;\n    }\n\n    .rs_activities-btn::-webkit-scrollbar-thumb {\n        -webkit-border-radius: 5px;\n        border-radius: 5px;\n        background-color: #999999 !important;\n        width: 2px !important;\n        height: 2px !important;\n    }\n\n    .rs_activities-btn::-webkit-scrollbar-thumb:hover {\n        background: #757d85;\n    }\n}\n\n/* Small devices (landscape phones, less than 768px) */\n@media (max-width: 767px) {\n    .rs_modal {\n        width: 90%;\n    }\n\n    .rs_container {\n        max-width: 95%;\n    }\n\n    .rs_have_a_question-section {\n        max-width: 100%;\n        width: 98%;\n    }\n\n    .rs_chatbot-chat-btn-send {\n        /* right: 15px; */\n    }\n\n    .rs_chatbot-input {\n        /* padding-right: 45px; */\n        /* padding-right: 0; */\n        width: 100%;\n    }\n\n    .rs_chatbot-input-form {\n        /* width: 100%; */\n    }\n\n    .rs_chatbot-input-form form {\n        width: 100%;\n    }\n\n    .rs_model-icon img {\n        width: 25px;\n    }\n\n    .rs_chat-header-icon h3 {\n        font-size: 16px;\n    }\n\n    .rs_cta-btn {\n        font-size: 10px;\n        height: 30px;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
